import React, { useEffect, useState } from "react";
import { Grid, Heading } from "@chakra-ui/react";
import EventCard from "../components/EventCard";
import Menu from "../components/Menu";
import { setTitle } from "../helpers/title";
import { Link } from "react-router-dom";
import { baseService } from "../helpers/baseService";
import { config } from "../helpers/config";
import LoadingPage from "../components/LoadingPage";

export default function Home() {
  const [events, setEvents] = useState([]);
  const [loadingPage, setLoadingPage] = useState(false);

  useEffect(() => {
    setTitle("Event | Home");
  }, []);

  useEffect(() => {
    setLoadingPage(true);
    baseService.get(
      config.services.global.getEvent,
      (res) => {
        setEvents(res.data);
      },
      (err) => console.log(err)
    );
    setLoadingPage(false);
  }, []);

  return (
    <div>
      <div className="container" />
      <div className="content">
        {loadingPage && <LoadingPage />}
        <Heading size="lg" mb={6}>
          Events
        </Heading>
        {events.length > 0 ? (
          events.map((event) => {
            return (
              <Link to={`/event/${event._id}`} key={event._id}>
                <EventCard data={event} />
              </Link>
            );
          })
        ) : (
          <Grid placeItems="center" minHeight="var(--page-height)">
            belum ada event
          </Grid>
        )}
      </div>
      <Menu />
    </div>
  );
}
